"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Describes the type of contract the customer picked.
 */
var KeuzeTarief;
(function (KeuzeTarief) {
    /**
     * For example E HH Variabel Grijs Budget Looptijd vast
     */
    KeuzeTarief["BUDGET"] = "B";
    /**
     * E HH Variabel Groen Plus Looptijd flex
     */
    KeuzeTarief["PLUS"] = "P";
    /**
     * E HH Variabel Grijs Stndrd Vrdl Lpt flex
     */
    KeuzeTarief["STANDAARD"] = "S";
    /**
     * For example E HH Zekerheid grijs 1 jaar
     * Or E SME Vast & Zeker Grijs 3 jaar
     */
    KeuzeTarief["OTHER"] = "N";
})(KeuzeTarief || (KeuzeTarief = {}));
exports.default = KeuzeTarief;
